import state from "./state";
import actions from './actions'
import mutations from './mutations'

const identidyOpenStatus = {
  namespaced: true,
  state,
  mutations,
  actions
}
export default identidyOpenStatus;